import React from 'react'
import { Image, Modal, Button } from "react-bootstrap";
import {
  ModalTile,
  ModalButton,
} from './deletereviewStyle'
import { useDispatch } from 'react-redux';
import { deleteReviewHandler } from '../../../redux/slices/donationCamp/deleteReview-slice';
import { useNavigate } from 'react-router-dom';
import { retrieveReviewsAction } from '../../../redux/slices/donationCamp/retrieveReviews-slice';

interface DeletereviewProps {
  editDeletereviewOpen: any;
  setDeletereviewOpen: any;
  deleteReviewId: string;
  slug: string;

}
const DeletereviewModal: React.FC<DeletereviewProps> = ({ editDeletereviewOpen, setDeletereviewOpen, deleteReviewId, slug }: DeletereviewProps) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const deleteUserReview = () => {
    deleteReviewId && dispatch(deleteReviewHandler(deleteReviewId, "") as any);
    dispatch(retrieveReviewsAction.retrieveReviewsSliceReset());
    navigate(`/org/${slug}`)

  }
  return (
    <Modal show={editDeletereviewOpen} className='claim-nonprofit-modal donateModal'
      onHide={() => setDeletereviewOpen(false)} centered>
      <Modal.Header closeButton></Modal.Header>
      <Modal.Body>
        <ModalTile>Are you sure you want to remove this review?</ModalTile>
        <ModalButton> <Button onClick={deleteUserReview}>Delete</Button></ModalButton>

      </Modal.Body>
    </Modal>
  )
}

export default DeletereviewModal;
